export default __webpack_public_path__ + "static/media/Flaming Dragon Fist.8902a27b.png";